"use client";

import type { ReactNode } from "react";
import { HeroMapProvider } from "@/components/home/context/HeroMapContext";
import { ListingBrowseProvider } from "./context/listing-browse-context";
import { ListingBrowseContent } from "./listing-browse-content";
import type { BrowseListing } from "@/components/listing/browse/marketplace-listing";
import type { ListingSearchState } from "../utils/parseSearchParams";
import type { ListingFilterState } from "./context/listing-browse-state";

function initialFilters(
  search: ListingSearchState,
  saleOnly: boolean,
): Partial<ListingFilterState> {
  return {
    productType: search.productType ?? null,
    searchQuery: search.searchQuery ?? "",
    intentFilter: saleOnly ? "all" : (search.intentFilter ?? "all"),
    conditions: search.conditions ?? [],
    priceRange: search.priceRange ?? { min: null, max: null },
    stateCode: search.stateCode ?? null,
    listedAfterDays: search.listedAfterDays ?? null,
  };
}

interface ListingBrowsePageProps {
  initialListings?: BrowseListing[];
  initialTotalCount?: number;
  seoLinks?: ReactNode;
  header?: ReactNode;
  lockedProductType?: string;
  pageTitle?: string;
  saleOnly?: boolean;
  initialSearch?: ListingSearchState;
}

export function ListingBrowsePage({
  initialListings,
  initialTotalCount,
  seoLinks,
  header,
  lockedProductType,
  pageTitle,
  saleOnly,
  initialSearch,
}: ListingBrowsePageProps) {
  return (
    <HeroMapProvider initialSearch={initialSearch}>
      <ListingBrowseProvider
        lockedProductType={lockedProductType}
        pageTitle={pageTitle}
        saleOnly={saleOnly}
        initialState={
          initialSearch
            ? initialFilters(initialSearch, saleOnly ?? false)
            : undefined
        }
      >
        <ListingBrowseContent
          initialListings={initialListings}
          initialTotalCount={initialTotalCount}
          seoLinks={seoLinks}
          header={header}
        />
      </ListingBrowseProvider>
    </HeroMapProvider>
  );
}
